import { Injectable } from '@angular/core';
import { HttpService } from './http.service';

@Injectable()
export class NoEmpidService {

  constructor(private httpService: HttpService) { }

  getCertListWithNoEmpid() {
    return this.httpService.get('/hradmin/getCertLstWithoutEmpID');
  }

  updateEmpidForCert(certid, type, empid, statuscode) {
    let body = {
      "appLang": "fr",
      "certificateID": certid,
      "recordupdatedby": sessionStorage.getItem('user')
    };
    if (type === 'empid') {
      body['empID'] = empid;
    }
    if (type === 'statuscode') {
      body['statushradmin'] = statuscode;
    }
    return this.httpService.post('/hradmin/updateEmpIDForCert', body);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/no-empid.service.ts